import React from 'react';

import { FileType } from '../../../../types/common.types';

import { useDocumentApi } from '../../../../api/document/useDocumentApi';

import { downloadFile } from '../../../../utils/util';

import TribeFiles from '../../../../components/screens/programme/tribe/tribe-files/TribeFiles';

type Props = {
  files: FileType[];
  deleteFile?: (file: FileType) => void;
  post?: boolean;
  comment?: boolean;
};

const TribeFilesContainer = ({ files, deleteFile, post = false, comment = false }: Props) => {
  const { downloadDocument } = useDocumentApi();

  if (files.length === 0) return null;

  const downloadTribeFile = (file: FileType) => {
    const { documentExternalReference, name } = file;

    if (!documentExternalReference || !name) return;

    downloadDocument({ documentExternalReference }, (data) => downloadFile(data, name));
  };

  return (
    <TribeFiles files={files} downloadFile={downloadTribeFile} deleteFile={deleteFile} comment={comment} post={post} />
  );
};

export default TribeFilesContainer;
